export default function(to, from, next) {
  if (from.name === "Start") {
    window.store.commit("Order/initialState");
    next();
    return;
  }
  next();
}
